export default __webpack_public_path__ + "static/blob7-e81b86094edbb2699831735d530fd6f4.svg";